import { Link } from "react-router-dom";
import { GridFourIcon as GridIcon } from "@phosphor-icons/react";
import { stateClass, stateLabel } from "@/lib/dispositionConstants";

/** Compact disposition status for the Risk Brief page (mirrors the PDF section). */
export default function DispositionSummaryCard({ workspaceId, summary }) {
  if (!summary?.has_dispositions) return null;
  const s = summary.by_state || {};
  const validated = summary.validated || [];
  return (
    <div className="ml-card" data-testid="brief-disposition-section">
      <div className="px-4 pt-4 pb-3 flex items-start justify-between gap-3">
        <div>
          <div className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)] flex items-center gap-1.5">
            <GridIcon size={12} weight="bold" /> Disposition &amp; treatment
          </div>
          <div className="text-sm text-[var(--ml-text-secondary)] mt-1">
            {summary.total} object(s) positioned — <strong className="text-[#0e6027]">{s.validated || 0} validated</strong>, {summary.unvalidated} still proposed, {s.rejected || 0} rejected.
            {summary.stale > 0 && (
              <span className="text-[#8a3800]" data-testid="brief-disposition-stale"> <strong>{summary.stale} stale</strong> — driving signal no longer fires; review before validating.</span>
            )}
          </div>
        </div>
        <Link to={`/workspaces/${workspaceId}/dispositions`} className="text-xs text-[var(--ml-primary)] hover:underline whitespace-nowrap" data-testid="brief-open-dispositions">
          Open matrix →
        </Link>
      </div>
      {validated.length > 0 ? (
        <ul className="border-t border-[var(--ml-border)] divide-y divide-[var(--ml-border)]" data-testid="brief-validated-list">
          {validated.slice(0, 8).map((v) => (
            <li key={`${v.object_kind}-${v.library_name}-${v.object_name}`} className="px-4 py-2 flex items-center gap-3 text-xs">
              <span className="ml-mono font-semibold">{v.library_name}/{v.object_name}</span>
              <span className="text-[var(--ml-text-secondary)]">{v.technical_treatment} → {v.migration_disposition}</span>
              <span className={`ml-auto ml-mono text-[10px] uppercase tracking-widest px-1.5 py-0.5 border ${stateClass("validated")}`}>{stateLabel("validated")}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="px-4 pb-4 text-xs text-[#8a6d00]" data-testid="brief-no-validated-note">
          No dispositions validated yet — every position is a deterministic proposal, not a decision.
        </p>
      )}
    </div>
  );
}
